import { createTheme } from '@mui/material/styles';
import { typography } from './typography';
import { breakpoints } from './breakpoints';
import { components } from './components';
import { brandOverride } from '../clients/brandOverride';

export const darkTheme = createTheme({
  typography,
  components,
  breakpoints,
  palette: {
    accent: {
      main: '#2f3336',
      secondary: '#71767b',
    },
    background: {
      default: '#121212',
      secondary: '#181818',
    },
    primary: {
      main: '#121212',
    },
    secondary: {
      main: '#ffffff',
    },
    default: {
      main: '#ffffff',
    },
    error: {
      main: '#d32f2f',
    },
    neons: {
      pink: '#f000ff',
      blue: '#4deeea',
      green: '#74ee15',
      yellow: '#ffe700',
      orange: '#FF5F1F',
      purple: '#BC13FE',
      red: '#FF3131',
    },
    medal: {
      main: '#C0C0C0',
    },
    ...brandOverride().brandColors,
  },
});
